"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 10 29 2018
 */

var DomainObject_1 = require("../DomainObject");
/**
 * Abstract entity filter.
 *
 * @author JMe
 */


var AbstractEntityFilter =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(AbstractEntityFilter, _DomainObject_1$Domai);

  /**
   * @param limit number of records to return
   * @param offset starting index (skip number of items)
   */
  function AbstractEntityFilter(limit, offset) {
    var _this;

    _classCallCheck(this, AbstractEntityFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractEntityFilter).call(this));
    _this.limit = limit;
    _this.offset = offset;
    return _this;
  }
  /**
   * @param limit number of records to return
   * @returns filter with limit
   * @deprecated use Overview/Pagination object
   */


  _createClass(AbstractEntityFilter, [{
    key: "withLimit",
    value: function withLimit(limit) {
      return this.copy('limit', limit);
    }
    /**
     * @param offset starting index (skip number of items)
     * @returns filter with offset
     * @deprecated use Overview/Pagination object
     */

  }, {
    key: "withOffset",
    value: function withOffset(offset) {
      return this.copy('offset', offset);
    }
  }, {
    key: "with",
    value: function _with(field, value) {
      if (value !== undefined && value !== null) {
        return this.copy(field, value);
      }

      return this;
    }
  }]);

  return AbstractEntityFilter;
}(DomainObject_1.DomainObject);

exports.AbstractEntityFilter = AbstractEntityFilter;